module.exports = __webpack_public_path__ + "media/images/edion/top/1-8fded02036d4f96be53937c032d50f76.png";